import usePagination from '@/hooks/usePagination';
import { CertificateTemplatesFilters, Maybe, SortType } from '@/types/schema';

import { useCertificateTemplatesQuery } from '../graphql/queries/generated/certificateTemplates';

function useCertificateTemplates({
  filters,
  sort,
}: {
  filters: CertificateTemplatesFilters;
  sort?: Maybe<SortType[]>;
}) {
  const { data, isFetchingMore, error, refetch, fetchMore, isFetching, totalCount } = usePagination(
    useCertificateTemplatesQuery,
    {
      filters,
      sort,
    },
    {
      edgeKey: 'certificateTemplates',
    },
  );

  return {
    initialFetching: isFetching,
    isFetchingMore,
    error,
    certificateTemplates: data,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useCertificateTemplates;
